//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

// Our collection of very simple but useful directives. Anything big/complex should go in it's own js file!
(function() {
  const curalate = angular.module('curalate');

    // parseInteger - Converts the model of an input or select element to an integer.
    // This is useful for roundtripping a JSON number from service to view and back to service.
    //
    // Usage: <select ngModel="obj.myInt" parse-integer>...</select>
    //
  curalate.directive('integer',
        () => {
          return {
            restrict: 'A',
            require: 'ngModel',
            link(scope, ele, attr, ctrl) {
              ctrl.$parsers.unshift((viewValue) => {
                return parseInt(viewValue, 10);
              });

              ctrl.$formatters.push((viewValue) => {
                return `${viewValue}`;
              });
            },
          };
        },
    );

    /**
     * A more performant version of ng-click which takes advantage of the distinction between scope.$digest and scope.$apply.
     *
     * Note: This method should only be used when the click event is updating data watched by watchers in the current scope.  If watchers outside
     * of the scope are depending on this data (e.g. something outside of an ng-repeat, something in a directive with isolate scope, etc) then DO
     * NOT USE THIS METHOD.
     *
     * With ng-click, a scope.$apply is invoked, which causes all watchers across the entire scope chain to be invoked.  This method
     * provides the same functionality as ng-click, but invokes scope.$digest instead of scope.$apply, which will only trigger watchers in the
     * CURRENT scope.
     *
     * For more information see: http://www.bennadel.com/blog/2595-using-scope-digest-as-a-performance-optimization-in-angularjs.htm
     *
     */
  curalate.directive('scopeClick', [
    '$parse',
    function(
            $parse,
        ) {
      return {
        restrict: 'A',
        scope: false,
        link(scope, element, attrs) {
          const fn = $parse(attrs.scopeClick, null, true);

          element.click(() => {
            fn(scope);
            scope.$digest(); // Triggers all watchers in the current scope ONLY.
          });
        },
      };
    },
  ]);

  curalate.directive('indeterminate',
        () => {
          return {
            restrict: 'A',
            link(scope, element, attributes) {
              scope.$watch(attributes.indeterminate, (value) => {
                element.prop('indeterminate', !!value);
              });
            },
          };
        },
    );

  curalate.directive('simplePopover', [
    '$parse',
    function($parse) {
      return {
        restrict: 'A',
        scope: {
          content: '@simplePopover',
          popoverPlacement: '@?',
          popoverContainer: '@?',
        },
        compile($element, attrs) {
          const isHtml = _.has(attrs, 'popoverHtml');
          const trigger = attrs.popoverTrigger ? $parse(attrs.popoverTrigger) : 'hover';
          const customClass = attrs.popoverCustomClass ? $parse(attrs.popoverCustomClass) : null;
          const delay = attrs.popoverShowDelay ? { show: parseInt(attrs.popoverShowDelay, 10) } : null;
          if (attrs.popoverHideDelay) {
            _(delay).extend({ hide: parseInt(attrs.popoverHideDelay, 10) });
          }

          return function(scope, elem) {
            let customTemplate;

            const popoverOptions = {
              content() {
                return scope.content;
              },
              html: isHtml,
              placement: scope.popoverPlacement || 'top',
              trigger: _.isFunction(trigger) ? trigger(scope) : trigger,
              container: scope.popoverContainer || 'body',
              delay,
            };

            if (customClass) {
              customTemplate = angular.element($.fn.popover.Constructor.DEFAULTS.template).addClass(customClass(scope));
              popoverOptions.template = customTemplate[0].outerHTML;
            }

            elem.popover(popoverOptions);
          };
        },
      };
    },
  ]);

    // Mostly cloned from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngEventDirs.js#L48
  ['ended', 'playing'].forEach((evtName) => {
    const dirName = `ng${evtName[0].toUpperCase()}${evtName.slice(1)}`;
    curalate.directive(dirName, [
      '$parse',
      function(
                $parse,
            ) {
        return {
          restrict: 'A',
          compile($element, attr) {
            const fn = $parse(attr[dirName], /* interceptorFn */ null, /* expensiveChecks */ true);
            return function ngEventHandler(scope, element) {
              element.on(evtName, (event) => {
                const callback = function() {
                  fn(scope, { $event: event });
                };
                scope.$apply(callback);
              });
            };
          },
        };
      },
    ]);
  });

  curalate.directive('onFinishRender', [
    '$timeout',
    function(
            $timeout,
        ) {
      return {
        restrict: 'A',
        link(scope, element, attr) {
          if (scope.$last === true) {
            $timeout(() => {
              scope.$emit(attr.onFinishRender);
            });
          }

          scope.$on('$destroy', () => {
            scope.$emit(attr.onFinishRender);
          });
        },
      };
    },
  ]);
})();
